import { render, staticRenderFns } from "./NetworkContribution.vue?vue&type=template&id=8c57aea4&scoped=true"
import script from "./NetworkContribution.vue?vue&type=script&lang=js"
export * from "./NetworkContribution.vue?vue&type=script&lang=js"
import style0 from "./NetworkContribution.vue?vue&type=style&index=0&id=8c57aea4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c57aea4",
  null
  
)

/* custom blocks */
import block0 from "./NetworkContribution.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports